// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `angular-cli.json`.

export const environment = {
    production                       : false,
    rfidInnerCaseLabelBucket         : 'impreso.rfid.stage',
    innercaseRegenerateFilesFunction : 'Impreso-RFIDPrinterService-stage-InnerCaseLabel',
    generateBoxLabelsFunction        : 'Impreso-RFIDPrinterService-stage-rfidBoxLabel',
    magentoServiceApiUrl             : 'https://xhba1shraf.execute-api.us-east-1.amazonaws.com/dev',
    rfidLambdaEndpoint               : 'https://7upn5kt3bj.execute-api.us-east-1.amazonaws.com/dev',
    eodReportsBucket                 : 'impreso.sheet.eod.stage.reports',
    imposerTemplatesBucket           : 'impreso.sheet.imposer.stage.templates',
    imposerGHSBucket                 : 'impreso.sheet.imposer.stage.out',
    imposerInBucket                  : 'impreso.sheet.imposer.stage.in',
    checkAmazonTransactionFunction   : 'Impreso-AmazonShippingService-stage-checkTransactionStatus',
    authUsersFunction                : 'Impreso-AuthService-stage-Users',
    authUsersSettingUpdateFunction   : 'Impreso-AuthService-stage-UsersSettingUpdate',
    loginFunction                    : 'Impreso-AuthService-stage-LambdAuthLogin',
    registerFunction                 : 'Impreso-AuthService-stage-LambdAuthCreateUser',
    verifyFunction                   : 'Impreso-AuthService-stage-LambdAuthVerifyUser',
    checkRoleFunction                : 'Impreso-AuthService-stage-LambdAuthCheckRole',
    lostPasswordFunction             : 'Impreso-AuthService-stage-LambdAuthLostPassword',
    resetPasswordFunction            : 'Impreso-AuthService-stage-LambdAuthResetPassword',
    adminRegisterFunction            : 'Impreso-AuthService-stage-LambdAuthAdminCreateUser',
    adminResetPasswordFunction       : 'Impreso-AuthService-stage-LambdAuthAdminResetPassword',
    changePasswordFunction           : 'Impreso-AuthService-stage-LambdAuthChangePassword',
    templateFunction                 : 'Impreso-TemplateService-stage-Templates',
    imposerPdfFunction               : 'Impreso-ImposerService-stage-SheetImposerApi',
    downloadEODReportFunction        : 'Impreso-EODService-stage-downloadReport',
    EODFunction                      : 'Impreso-EODService-stage-graphql',
    processEODFunction               : 'Impreso-EODService-stage-startProcessEOD',
    batchFunction                    : 'Impreso-BatchService-stage-graphql',
    magentoFunction                  : 'Impreso-MagentoService-stage-graphql',
    magentoTemplateLaserFlagMapFunction : 'Impreso-MagentoService-stage-getTemplateLaserFlagMapping',
    magentoMaterialLaserFlagMapFunction : 'Impreso-MagentoService-stage-getMaterialLaserFlagMapping',
    magentoUpdateLaserFlagFunction   : 'Impreso-MagentoService-stage-updateMaterialTemplateLaserFlag',
    printWorkOrderFunction           : 'Impreso-PrinterService-stage-WorkOrder',
    printRfidWorkOrderFunction       : 'Impreso-RFIDPrinterService-stage-RfidWorkOrder',
    laserWorkOrderFunction           : 'Impreso-PrinterService-stage-LaserWorkOrder',
    laserRegenarateFilesFunction     : 'Impreso-MagentoService-stage-laserRegenFiles',
    printerCertFunction              : 'Impreso-PrinterService-stage-GetQZCertificate',
    printerPackingSlipFunction       : 'Impreso-PrinterService-stage-PackingSlip',
    printRFIDPackingSlipFunction     : 'Impreso-RFIDPrinterService-stage-rfidPackingSlip',
    printerPDFAddonsFunction         : 'Impreso-PrinterService-stage-PDFAddons',
    printerPackagingLabelFunction    : 'Impreso-PrinterService-stage-PackagingLabel',
    printerSignFunction              : 'Impreso-PrinterService-stage-Sign',
    reportRequestFunction            : 'Impreso-ReportingService-stage-reportRequest',
    materialUsageRequestFunction     : 'Impreso-ReportingService-stage-generateMaterialUsageReport',
    scrapReportFunction              : 'Impreso-BatchService-stage-scrapReport',
    settingFunction                  : 'Impreso-SettingsService-stage-graphql',
    shipmentFunction                 : 'Impreso-ShipmentService-stage-graphql',
    shipmentDeliveryEstimatesFunction: 'Impreso-ShipmentService-stage-DeliveryEstimates',
    shipmentValidateAddressFunction  : 'Impreso-ShipmentService-stage-ValidateAddress',
    shipmentSpeedAdjustmentFunction  : 'Impreso-ShipmentService-stage-ShippingSpeedAdjustment',
    shipmentTrackFunction            : 'Impreso-ShipmentService-stage-TrackShipment',
    shipmentVoidFunction             : 'Impreso-ShipmentService-stage-VoidShipment',
    authProviderId                   : 'login.impreso.com',
    region                           : 'us-east-1',
    iot_endpoint                     : 'ahuxcpjwypzl6-ats.iot.us-east-1.amazonaws.com',
    identityPoolId                   : 'us-east-1:3ea78817-8850-43b1-a80f-b63b36cb7e67',
    stage                            : 'stage',
    batchesTopic                     : 'BATCHES_stage',
    binsTopic                        : 'BINS_stage',
    diesTopic                        : 'DIES_stage',
    eodTopic                         : 'EOD_stage',
    horizonsTopic                    : 'HORIZONS_stage',
    horizonStatsTopic                : 'HORIZON_STATS_stage',
    jobsTopic                        : 'JOBS_stage',
    ordersTopic                      : 'ORDERS_stage',
    productsTopic                    : 'PRODUCTS_stage',
    scrapsTopic                      : 'SCRAPS_stage',
    settingsTopic                    : 'SETTINGS_stage',
    shipmentsTopic                   : 'SHIPMENTS_stage',
    subAssembliesTopic               : 'SUBASSEMBLIES_stage',
    templatesTopic                   : 'TEMPLATES_stage',
    usersTopic                       : 'USERS_stage',
    yellowBagsTopic                  : 'YELLOWBAGS_stage',
    holdBinsTopic                    : 'HOLDBINS_stage',
    jobLocationsTopic                : 'JOB_LOCATIONS_stage',
    rolesTopic                       : 'ROLES_stage',
    prestaSubassemblyConfigTopic     : 'PRESTA_SUBASSEMBLY_CONFIG_stage',
    ptoBinsTopic                     : 'PTO_BINS_stage',
    diePressureThreshold             : 5
};



// WEBPACK FOOTER //
// /Users/jlam2/impresocloud/www/client/src/environments/environment.ts